import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

export class VisitorTypeRelatedImageController extends AbstractStepController {

  private dialogService: DialogService;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {

  }

  onRegisterToDashboardContext() {
    const visitorTypeId = this.dashboardContext.getContextValue('visitorType');
    const language = this.dashboardContext.getContextValue(TerminalContextConstants.language);
    const imageUrl = this.resolveImageForVisitorRole('' + visitorTypeId, '' + language);
    this.dashboardContext.setContextValue('visitorRoleRelatedImageUrl', imageUrl);
  }


  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('visitor type related image started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const nextControl = new StepControl();
    nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
    nextControl.type = StepControlType.BUTTON;
    nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    nextControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.next();
    };
    controls.push(nextControl);

    return controls;
  }



  private resolveImageForVisitorRole(visitorTypeId: string, language: string) {
    const config = this.wizardComponent.currentStep.dashboardConfiguration?.visitorTypeImageMapping;
    const imageUrl = (config[visitorTypeId] as string).replace('{visitorTypeId}', visitorTypeId).replace('{language}', language);
    return imageUrl;
  }

}
